export default "__VITE_ASSET__BwSnjNzJ__"